package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.chat_model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
data class ChatMessageHistoryModel(
    @SerialName("chat_message_history")
    var chatMessageHistory: MutableList<ChatSingleMessageModel>,
    @SerialName("favorite_messages")
    var favoriteMessages: MutableList<String>,
    @SerialName("free_tokens")
    val freeTokens: Long? = null,
    @SerialName("premium_tokens")
    val premiumTokens: Long? = null
)
